module.exports = __webpack_public_path__ + "fb3a841b8023f8311dea902fa138d933.svg";